import React, { useCallback, useState } from 'react';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { CART_URL, CART_URL_PUBLISH, COOKIE_ORDER_NUMBER_KEY } from '@yme/common/constants';
import { setInitialCartState } from '@yme/common/redux/cart/actions';
import { COOKIE_CART_ID_KEY, PAYMENT_LINK_PROVIDER } from '@yme/common/redux/cart/constants';
import { deleteCartItems } from '@yme/common/redux/cart/services';
import { CheckoutStepsHashes, CheckoutSteps } from '@yme/components/CheckoutForm/constants';
import { setIsModalHide } from '@yme/modals/actions';
import { getModalData } from '@yme/modals/selectors';
import { getRTL, getLanguageRootPath, getAnotherSessionLabels, getIsInAuthor, } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { CartBroadcastEvents } from '@yme/utils/constants';
import { broadcastCart } from '../../App';
import { ModalState, ICON_MAP } from './constants';
import { getSubmitButtonLabel, getOnSubmitCallback } from './helpers';
import { IconWrapper } from './styled';
const COOKIE_KEYS = [COOKIE_CART_ID_KEY, COOKIE_ORDER_NUMBER_KEY, PAYMENT_LINK_PROVIDER];
export function AnotherSessionModal() {
    const [modalState, setModalState] = useState(ModalState.INITIAL);
    const isRightToLeft = useSelector(getRTL);
    const languageRootPath = useSelector(getLanguageRootPath);
    const isInAuthor = useSelector(getIsInAuthor);
    const modalData = useSelector(getModalData);
    const { anotherSessionMessage, clearButton, continueButton, modalHeader, successButton, successMessage, successModalHeader, } = useSelector(getAnotherSessionLabels);
    const dispatch = useDispatch();
    const history = useHistory();
    const handleHideModal = useCallback(() => {
        dispatch(setIsModalHide());
    }, [dispatch]);
    const removeCookie = (key) => {
        Cookies.remove(key, {
            path: `${languageRootPath}/`,
        });
    };
    const handleProceedToCheckout = () => {
        handleHideModal();
        history.push(`${languageRootPath}/${isInAuthor ? CART_URL : CART_URL_PUBLISH}`);
    };
    const handleClearCart = async () => {
        try {
            await dispatch(deleteCartItems());
            dispatch(setInitialCartState());
            COOKIE_KEYS.forEach(removeCookie);
            if (CheckoutStepsHashes.slice(1).includes(history.location.hash)) {
                history.push({
                    hash: CheckoutSteps.CART,
                });
            }
            setModalState(ModalState.SUCCESS);
            broadcastCart.postMessage(CartBroadcastEvents.CART_UPDATED);
        }
        catch (err) {
            console.warn(err);
        }
    };
    const submitButtonLabel = getSubmitButtonLabel(modalState, modalData?.isAddToCart, modalData?.isCartPage, {
        successButton,
        clearButton,
        continueButton,
    });
    const cancelButtonLabel = modalData?.isAddToCart ? continueButton : clearButton;
    const modalFooter = (React.createElement(ModalWindowFooter, { isWrapReverse: true, isSubmitButton: true, isCancelButton: modalState === ModalState.INITIAL && !modalData?.isCartPage, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, onCancel: modalData?.isAddToCart ? handleProceedToCheckout : handleClearCart, onSubmit: getOnSubmitCallback(modalState, modalData?.isAddToCart, modalData?.isCartPage, {
            handleHideModal,
            handleClearCart,
            handleProceedToCheckout,
        }), isCancelButtonFullWidth: true, isSubmitButtonFullWidth: true }));
    return (React.createElement(StaticModalWindow, { title: modalState === ModalState.INITIAL ? modalHeader : successModalHeader, staticModalSize: MD_MODAL, minHeight: "auto", isRightToLeft: isRightToLeft, footerComponent: modalFooter, onHide: handleHideModal },
        React.createElement(FlexWrapper, { justifyContent: "center", isFullWidth: true, mb: INDENT.sm },
            React.createElement(IconWrapper, { modalState: modalState },
                React.createElement(SVGIcon, { type: ICON_MAP[modalState], size: ICON_SIZE.l }))),
        React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, modalState === ModalState.INITIAL ? anotherSessionMessage : successMessage)));
}
